"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _useNormalizeAndMapFilters = _interopRequireDefault(require("@deosite/api/hooks/common/useNormalizeAndMapFilters"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Container = _interopRequireDefault(require("@commerce-ui/core2/Container"));
var _RangePicker = _interopRequireDefault(require("@commerce-ui/core2/RangePicker"));
var _Button = _interopRequireDefault(require("@commerce-ui/core2/Button"));
var _ShowHide = _interopRequireDefault(require("@commerce-ui/core2/ShowHide"));
var _DialogUi = _interopRequireDefault(require("../DialogUi"));
var _SelectInline = _interopRequireDefault(require("@commerce-ui/core2/SelectInline"));
var _MultiSelectInline = _interopRequireDefault(require("@commerce-ui/core2/MultiSelectInline"));
var _Accordion = _interopRequireDefault(require("@commerce-ui/core2/Accordion"));
var _Select = _interopRequireDefault(require("@commerce-ui/core2/Select2"));
var _searchFilterByName = _interopRequireDefault(require("@deosite/helpers/searchFilterByName"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconArrowDown = function IconArrowDown(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
IconArrowDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconClose = function IconClose(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), __jsx("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};
IconClose.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
var ChevronUpIcon = function ChevronUpIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.35 8.07l6.42 6.42-.85.85-5.57-5.58-5.58 5.58-.85-.85z"
  }));
};
ChevronUpIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronDownIcon = function ChevronDownIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
ChevronDownIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var FiltersBarMobile = function FiltersBarMobile(props) {
  var onChange = props.onChange,
    data = props.data,
    button = props.button,
    buttonMinimal = props.buttonMinimal,
    input = props.input,
    itemRowCheckmark = props.itemRowCheckmark,
    buttonMinimalIcon = props.buttonMinimalIcon,
    isDialogMobileOpen = props.isDialogMobileOpen;
  var _useNormalizeAndMapFi = (0, _useNormalizeAndMapFilters["default"])({
      data: data,
      onChange: onChange,
      isMobile: true
    }),
    filters = _useNormalizeAndMapFi.filters,
    commit = _useNormalizeAndMapFi.commit,
    clearAll = _useNormalizeAndMapFi.clearAll;
  var translations = {
    clear: (0, _langLibrary["default"])("Clear"),
    filter: (0, _langLibrary["default"])("Filter"),
    showResult: (0, _langLibrary["default"])("Show result"),
    sortBy: (0, _langLibrary["default"])("Sort"),
    showMore: (0, _langLibrary["default"])("show more"),
    showLess: (0, _langLibrary["default"])("show less"),
    from: (0, _langLibrary["default"])("from range"),
    to: (0, _langLibrary["default"])("to range"),
    final_price: (0, _langLibrary["default"])("price"),
    price: (0, _langLibrary["default"])("price"),
    length: (0, _langLibrary["default"])("Length [cm]"),
    width: (0, _langLibrary["default"])("Width [cm]"),
    shape: (0, _langLibrary["default"])("Shape"),
    producer: (0, _langLibrary["default"])("Producer"),
    height: (0, _langLibrary["default"])("Height [cm]"),
    depth: (0, _langLibrary["default"])("Depth [cm]"),
    capacity: (0, _langLibrary["default"])("Capacity [l]"),
    number_of_people: (0, _langLibrary["default"])("Number of people"),
    dajar_collection: (0, _langLibrary["default"])("Dajar collection"),
    material: (0, _langLibrary["default"])("Material"),
    application: (0, _langLibrary["default"])("Application"),
    diameter: (0, _langLibrary["default"])("Diameter [cm]"),
    color_list: (0, _langLibrary["default"])("Color list"),
    pattern_list: (0, _langLibrary["default"])("Pattern list")
  };
  var MultiLineOptions = function MultiLineOptions(selectProps) {
    var _useState = (0, _react.useState)(false),
      optionsVisible = _useState[0],
      setOptionsVisible = _useState[1];
    return __jsx(_Box["default"], null, __jsx(_MultiSelectInline["default"], selectProps, /*#__PURE__*/_react["default"].cloneElement(itemRowCheckmark, {
      isColor: selectProps.isColor,
      color: "active",
      optionsArray: selectProps.options,
      allVisible: optionsVisible
    })), selectProps.options.length > 10 && __jsx(_Button["default"], {
      sx: {
        color: "main",
        font: "label",
        width: "100%",
        mt: "s8",
        textAlign: "center"
      },
      onClick: function onClick() {
        return setOptionsVisible(!optionsVisible);
      }
    }, optionsVisible ? translations.showLess : translations.showMore));
  };
  var _useState2 = (0, _react.useState)(false),
    activeFilterOptions = _useState2[0],
    setActiveFilterOptions = _useState2[1];
  var filterOptionsByName = function filterOptionsByName(inputValue, options, filterName) {
    var filteredOptions = (0, _searchFilterByName["default"])(inputValue, options);
    setActiveFilterOptions(_objectSpread(_objectSpread({}, activeFilterOptions), {}, (0, _defineProperty2["default"])({}, filterName, filteredOptions)));
  };
  return __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      mb: "s8"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "50%",
      position: "relative"
    }
  }, __jsx(_DialogUi["default"], {
    sx: {
      height: "100%"
    },
    button: /*#__PURE__*/_react["default"].cloneElement(buttonMinimal, {
      sx: {
        width: "100%",
        height: 44
      },
      leftIcon: __jsx(IconArrowDown, null)
    }, translations.filter),
    placement: "bottom",
    height: "100%",
    root: {
      bg: "white",
      top: 0
    },
    isDialogMobileOpen: isDialogMobileOpen,
    anchoredTo: "window",
    header: function header(_ref) {
      var close = _ref.close;
      return __jsx(_Box["default"], {
        sx: {
          borderBottomColor: "neutral700",
          borderBottomStyle: "solid",
          borderBottomWidth: 1
        }
      }, __jsx(_Container["default"], null, __jsx(_Box["default"], {
        sx: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: 50
        }
      }, /*#__PURE__*/_react["default"].cloneElement(buttonMinimalIcon, {
        sx: {
          color: "main",
          position: "relative",
          right: "12px"
        },
        onClick: function onClick() {
          setActiveFilterOptions(false);
          close();
        }
      }, __jsx(IconClose, null)), /*#__PURE__*/_react["default"].cloneElement(buttonMinimal, {
        sx: {
          font: "s_sans_underline"
        },
        onClick: function onClick() {
          clearAll(true);
          close();
        }
      }, translations.clear))));
    },
    footer: function footer(_ref2) {
      var close = _ref2.close;
      return __jsx(_Box["default"], {
        sx: {
          borderBottomColor: "neutral",
          borderBottomStyle: "solid",
          borderBottomWidth: 1
        }
      }, __jsx(_Container["default"], null, __jsx(_Box["default"], {
        sx: {
          py: "s8"
        }
      }, /*#__PURE__*/_react["default"].cloneElement(button, {
        sx: {
          width: "100%"
        },
        onClick: close
      }, translations.showResult))));
    },
    onClose: commit
  }, __jsx(_Container["default"], {
    sx: {
      mb: "s9"
    }
  }, filters.map(function (filter, index) {
    if (filter.id === "sort") {
      return;
    }
    var createFilter = function createFilter(type) {
      var _filter$name;
      switch (type) {
        case "select":
          return __jsx(_SelectInline["default"], filter.soft.selectProps, /*#__PURE__*/_react["default"].cloneElement(itemRowCheckmark, {
            color: "active",
            optionsArray: [],
            allVisible: true
          }));
        case "multiselect":
          return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
            sx: {
              mb: "s6",
              display: filter.id === "producer" || filter.id === "dajar_collection" ? "block" : "none"
            }
          }, /*#__PURE__*/_react["default"].cloneElement(input, {
            clearable: true,
            onChange: function onChange(e) {
              return filterOptionsByName(e, filter.soft.selectProps.options, filter.name, filter);
            },
            label: filter === null || filter === void 0 ? void 0 : (_filter$name = filter.name) === null || _filter$name === void 0 ? void 0 : _filter$name.toLowerCase()
          })), __jsx(MultiLineOptions, (0, _extends2["default"])({}, filter.soft.selectProps, {
            isColor: filter.id === "color_list",
            options: activeFilterOptions && activeFilterOptions[filter.name] ? activeFilterOptions[filter.name] : filter.soft.selectProps.options
          })));
        case "range":
          return __jsx(_RangePicker["default"], (0, _extends2["default"])({}, filter.soft.rangePickerProps, {
            inputFrom: /*#__PURE__*/_react["default"].cloneElement(input, {
              label: translations.from
            }),
            inputTo: /*#__PURE__*/_react["default"].cloneElement(input, {
              label: translations.to
            }),
            separator: __jsx(_Box["default"], {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                px: "s5",
                pb: "s5"
              }
            }, "-")
          }));
      }
    };
    var headerStyles = {
      mt: "s8",
      font: "base_sans_bold",
      mb: "s7",
      color: "main",
      height: 36,
      lineHeight: "36px"
    };
    return __jsx(_Box["default"], {
      key: filter.id,
      sx: {
        borderBottomWidth: filters.length - 1 === index ? "0" : "1px",
        borderStyle: "solid",
        borderColor: "neutral700",
        pb: index < 3 ? "s8" : 0,
        display: filter.isDisabled ? "none" : "block"
      }
    }, index < 3 ? __jsx(_Box["default"], null, __jsx(_Box["default"], {
      as: "h5",
      sx: headerStyles
    }, translations[filter.id]), createFilter(filter.type)) : __jsx(_Accordion["default"], null, __jsx(_Accordion["default"].Section, {
      isOpenAtInit: index === 0
    }, __jsx(_Button["default"], {
      sx: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        ":focus": {
          outline: 0,
          boxShadow: "none"
        },
        "::-moz-focus-inner": {
          border: 0
        }
      }
    }, function (_ref3) {
      var selected = _ref3.selected;
      return __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
        as: "h5",
        sx: headerStyles
      }, translations[filter.id]), __jsx(_Box["default"], null, selected ? __jsx(ChevronUpIcon, null) : __jsx(ChevronDownIcon, null), " "));
    }), __jsx(_ShowHide["default"], null, createFilter(filter.type), __jsx(_Box["default"], {
      sx: {
        mb: "s8"
      }
    }, " ")))));
  })))), __jsx(_Box["default"], {
    sx: {
      width: "calc(50% - 1px)",
      position: "relative",
      borderLeftWidth: "1px",
      borderStyle: "solid",
      borderColor: "neutral"
    }
  }, filters.find(function (filter) {
    return filter.id === "sort";
  }) && __jsx(_Select["default"], (0, _extends2["default"])({
    button: function button(_ref4) {
      var value = _ref4.value;
      return /*#__PURE__*/_react["default"].cloneElement(buttonMinimal, {
        sx: {
          width: "100%",
          height: 44
        },
        rightIcon: __jsx(IconArrowDown, null)
      }, value ? value.label : translations.sortBy);
    },
    anchoredTo: "window",
    placement: "bottom",
    selectable: /*#__PURE__*/_react["default"].cloneElement(itemRowCheckmark, {
      color: "active",
      rootStyles: {
        bg: "white",
        px: "5vw",
        py: "s5"
      },
      rounded: true,
      optionsArray: []
    }, translations.sortBy),
    header: __jsx(_Box["default"], {
      sx: {
        width: "100%",
        font: "base_sans_bold",
        color: "main",
        px: "5vw",
        py: "s8",
        background: "white"
      }
    }, translations.sortBy)
  }, filters.find(function (x) {
    return x.id === "sort";
  }).selectProps)))));
};
var _default = FiltersBarMobile;
exports["default"] = _default;